"use client";

import { Button } from "~/components/v3/themed/Button";
import { ClientSideSteps, ProfileEditRequiredData } from "../validators";
import EditProfileModal from "~/components/profile-components/EditProfileModal";
import { useState } from "react";
import { If } from "~/components/v3/Conditional";
import { useRouter } from "next/navigation";
import { CustomizableLayout } from "~/types/CustomizableLayout";

const MissingDataModalContent = ({
    onNext,
    setCurrentStep,
    eventSlug,
    setNextDisabled,
    attendeeMissingData,
    customization,
}: {
    onNext: () => void;
    setCurrentStep: (step: ClientSideSteps) => void;
    eventSlug: string;
    setNextDisabled: (disabled: boolean) => void;
    attendeeMissingData: ProfileEditRequiredData | null | undefined;
    customization?: CustomizableLayout;
}) => {
    const router = useRouter();
    const [showEditProfileModal, setShowEditProfileModal] = useState(false);
    const missingFields = Object.keys(attendeeMissingData ?? {});

    setNextDisabled(!!missingFields.length);
    if (!missingFields.length)
        return (
            <div className="flex flex-col gap-4">
                <div className="flex flex-col space-y-4">
                    <p>
                        Thank you for updating your profile! You can now RSVP to
                        this event.
                    </p>
                </div>
            </div>
        );

    return (
        <>
            <div className="flex flex-col gap-4">
                <div className="flex flex-col space-y-4">
                    <p>
                        You're missing some required data to be accepted to this
                        event
                    </p>
                    <ul className="text-base">
                        {missingFields.map((key) => (
                            <li key={key}>
                                •{" "}
                                <If condition={key === "minNameLength"}>
                                    too short profile name
                                </If>
                                <If condition={key === "minBioLength"}>
                                    profile bio is too short
                                </If>
                                <If condition={key === "imageRequired"}>
                                    profile image is required
                                </If>
                                <If condition={key === "chatLinks"}>
                                    no chat links provided
                                </If>
                                <If condition={key === "anySocialLinks"}>
                                    need to provide at least one social link
                                    (linkedin, X, facebook, etc)
                                </If>
                            </li>
                        ))}
                    </ul>
                    <Button
                        onClick={() => {
                            setShowEditProfileModal(true);
                        }}
                        className="w-full"
                        variant="secondary"
                    >
                        Complete profile
                    </Button>
                </div>
            </div>
            <EditProfileModal
                isVisible={showEditProfileModal}
                setVisible={(e) => {
                    setShowEditProfileModal(e);
                }}
                requiredData={attendeeMissingData}
                onSuccess={async () => {
                    router.refresh();
                }}
                customization={customization}
            />
        </>
    );
};

export default MissingDataModalContent;
